import * as React from 'react';
import * as ReactGA from 'react-ga';
import './case.css';
import { toastr } from 'react-redux-toastr';
import { ICase, CheckCaseId } from '../../../share/types/case/case';
import { connect } from 'react-redux';
import { IReduxState } from '../../../reduxTypes';
import { CasesService } from '../../../share/services/cases';
import { UploadPersonImages } from './helpers/uploadImages';
import { PersonHelper } from './helpers/persons';
import { ICaseUIProps, ICaseUIState, caseInitialState } from './types/types';
import * as _ from 'lodash';
import { UploadMiscImages } from './helpers/uploadMiscellaneous';
import { CaseContainer } from './layouts/Case';
import CaseSidebar from '../CaseSidebar/CaseSidebar';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';

const ENABLEDETLFIELDS = ['caseType', 'poster']


export class CaseComponent extends React.Component<ICaseUIProps, ICaseUIState> {
    public newCase: ICase;
    public upload: UploadPersonImages;
    public uploadMisc: UploadMiscImages;
    public person: PersonHelper;
    constructor(props: ICaseUIProps) {
        super(props);
        this.state = { ..._.cloneDeep(caseInitialState), component: new Date().getTime(), isModalOpen: false };
        this.person = new PersonHelper(this.getState, this.setValue);
    }

    public setValue = async (path: string, value: any) => {
        return new Promise(resolve => {
            this.setState(state => {
                state = this.setETLChangedValue(path, state);
                _.set(state, path, value)
                return state;
            }, resolve);
        })
    }
    public setETLChangedValue(path: string, state: ICaseUIState): ICaseUIState {
        if (this.props.isAnETLCase && typeof path === 'string' && path.startsWith('caseInfo.') && ENABLEDETLFIELDS.indexOf(path.replace('caseInfo.', '')) >= 0) {
            const newPath = path.replace('caseInfo.', 'caseInfo.updatedValues.');
            return _.set(_.cloneDeep(state), newPath, true)
        }
        return state;
    }
    public getState = () => {
        return this.state;
    }
    public modalToggle = (e?) => {
        if (e) {
            e.preventDefault()
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    }
    public closeCase = (e) => {
        e.preventDefault()
        this.goTo(`/close/${this.props.match.params.caseId}`, this.state.caseInfo.status === "closed")
    }

    public getCaseId = (url) => url.split("/").pop();

    public isEditCase = () => this.props.match.params.caseId;
    public wasClose = () => this.state.caseInfo.status === "closed";
    public componentDidMount() {
        this.loadData()
    }
    public componentDidUpdate(prevProps: ICaseUIProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.loadData()
        }
    }
    public loadData() {
        if (this.isEditCase()) {
            this.loadCase();
        } else {
            this.loadInitialCase();
            this.forceUpdate();
        }
    }
    public delete = async (id: string) => {
        this.setState({ loading: true })
        try {
            await CasesService.delete(id);
            this.goTo('/', false)
            toastr.success('Delete Case', 'The case has been deleted correctly');

            this.setState({ loading: false })
        } catch (error) {
            this.setState({ loading: false })
            toastr.error('There was a problem', 'The case could not be delete')
        }
    }
    public componentWillReceiveProps() {
        if (!this.isEditCase()) {
            this.loadInitialCase();
        }
    }

    public loadInitialCase = () => {
        const state = _.cloneDeep(caseInitialState);
        this.setState({ ...state, loading: false, component: new Date().getTime() });
    }

    public loadCase = async () => {
        this.setState({ loading: true });
        const caseId = this.getCaseId(window.location.pathname);
        try {
            const res = await CasesService.getCaseByID(caseId);
            this.setState({
                caseInfo: { ..._.cloneDeep(res), contactInformation: res.contactInformation || '' },
                loading: false,
                isEditCase: true,
                beforeUpdate: _.cloneDeep(res)
            });
        } catch (error) {
            toastr.error('Error', 'There was a problem loading the case');
            this.setState({ loading: false });
        }

    }
    public isReadOnly() {
        return this.state.caseInfo.status === "closed" || this.props.permissionCase === false || this.props.isAnETLCase
    }

    public form = (key: string, required?: boolean) => {
        return {
            disabled: this.isDisabled(key),
            name: key,
            required: required !== undefined ? required : true,
            value: _.get(this.state, `caseInfo.${key}`),
            onChange: (event) => this.setValue(`caseInfo.${key}`, event.currentTarget.value),
            onSelect: (event) => this.setValue(`caseInfo.${key}`, event.currentTarget.value)
        }
    }
    public isDisabled(key) {
        return this.state.loading || this.isReadOnly() && (this.props.isAnETLCase && ENABLEDETLFIELDS.indexOf(key) === -1)
    }

    public setCaseIdStatus = (valid: CheckCaseId) => {
        this.setValue(`caseIdStatus`, valid)
    }

    public handleInvalidSubmit() {
        toastr.error('Add Case', 'Please fill all the required values')
    }

    public isRegionValid() {
        const { country } = this.state.caseInfo
        if (country === "") {
            this.handleInvalidSubmit()
            return false;
        }
        return true
    }

    public handleValidSubmit = async () => {
        if (!this.isEditCase() && this.state.caseIdStatus !== CheckCaseId.Valid) {
            toastr.error('Error', this.getInvalidMessage())
            return;
        }
        if (this.isRegionValid()) {
            this.newCase = _.cloneDeep(this.state.caseInfo)
            try {
                await this.save()
            } catch (error) {
                this.setState({ loading: false, loadingMessage: '' })
                toastr.error('Error', 'There was a problem connecting to the server')
            }
        }
    }

    public getInvalidMessage() {
        if (this.state.caseIdStatus === CheckCaseId.InvalidCharacter) {
            return 'The case number has invalid characters'
        } else {
            return 'The case\'s id is being validated'
        }
    }

    public async save() {
        const { beforeUpdate, caseSaved } = this.state;

        if (!caseSaved) {
            this.setState({ loading: true, loadingMessage: `${beforeUpdate ? 'Updating' : 'Saving'} Case Data` })
            if (beforeUpdate) {
                await CasesService.update(_.cloneDeep(beforeUpdate), _.cloneDeep(this.newCase))
            } else {
                await CasesService.save(this.newCase)
            }
        }
        this.upload = new UploadPersonImages(this.setValue, this.newCase, this.getState)
        await this.upload.uploadImages();
        this.uploadMisc = new UploadMiscImages(this.setValue, this.newCase, this.getState)
        const miscToDelete = this.toDeletedMisc();
        if (miscToDelete.length > 0) {
            await this.uploadMisc.removeMiscellaneousImages(miscToDelete);
        }
        await this.uploadMisc.uploadMiscellaneous()
        this.setState({ loading: true, loadingMessage: '' })
        if (this.upload.wasErrorsUploadingImages() || this.uploadMisc.wasErrorsUploadingImages()) {
            toastr.error('There was a problem', 'Some of the images failed to upload, try again')
        } else {
            this.savedCorrectly()
        }
    }

    public toDeletedMisc = () => {
        const { beforeUpdate, caseInfo } = this.state;

        if (beforeUpdate && beforeUpdate.miscellaneous) {
            const current = caseInfo.miscellaneous ? caseInfo.miscellaneous : []
            const toDelete = beforeUpdate.miscellaneous.filter((num) => current.indexOf(num) === -1);
            return toDelete;
        }
        return [];
    }

    public savedCorrectly() {
        toastr.success('Add Case', 'The case has been saved correctly');
        ReactGA.event({
            category: 'Case',
            action: `${this.isEditCase() ? 'Updated' : 'Add new'} case`,
            label: 'Cases management'
        });
        this.props.history.replace(`/case/edit/${this.state.caseInfo.agencyCode}-${this.state.caseInfo.caseId}`);
        this.setState({ component: new Date().getTime(), isModalOpen: false, loading: false, imageUploadingStatus: {} });
    }

    public handleSubmit = () => {
        this.setValue('submitted', true)
    }
    public goTo(url, isClose) {
        if (!isClose) {
            this.props.history.push(url);
        }
    }
    public render() {
        return <CaseContainer key={'case'} that={this} className="case-container" />
    }
}
const mapStateToProps = (state: IReduxState) => ({
    auth: state.auth
});
export default SidebarContainer(CaseSidebar)(connect(mapStateToProps)(CaseComponent));
export const EditCase = connect(mapStateToProps)(CaseComponent);


// WEBPACK FOOTER //
// ./src/modules/Case/Add/Case.tsx